// extracted by mini-css-extract-plugin
export default {"container":"styles_container__jOjtB","container__mobile":"styles_container__mobile__2D0vQ","title":"styles_title__pUM7J","value":"styles_value__j1cik"};